import apiService from '../utils/apiService';

import {
  ADD_COMPLEMENT_REQUEST_APPROVAL,
  ADD_COMPLEMENT_REQUEST_APPROVAL_START,
  ADD_COMPLEMENT_REQUEST_APPROVAL_ERROR,
  GET_COMPLEMENT_REQUEST_APPROVAL_LAST,
  GET_COMPLEMENT_REQUEST_APPROVAL_LAST_START,
  GET_COMPLEMENT_REQUEST_APPROVAL_LAST_ERROR,
  GET_COMPLEMENT_REQUEST_APPROVAL_LIST_BY_REQUEST,
  GET_COMPLEMENT_REQUEST_APPROVAL_LIST_BY_REQUEST_START,
  GET_COMPLEMENT_REQUEST_APPROVAL_LIST_BY_REQUEST_ERROR,
  CLEAR_COMPLEMENT_REQUEST_APPROVAL,
} from './types';

import {
  complementRequestApprovalAddPath,
  complementRequestApprovalFindLastByRequestPath,
  complementRequestApprovalFindAllByRequestPath,
} from '../constants/apiEndpoints';
import {
  notificationTypeInfo,
  notificationTypeError,
} from '../constants/globals';

import { createNotification } from '../utils';

const addComplementRequestApprovalStart = () => {
  return {
    type: ADD_COMPLEMENT_REQUEST_APPROVAL_START,
  };
};
const addComplementRequestApprovalSuccessfully = (data) => {
  return {
    type: ADD_COMPLEMENT_REQUEST_APPROVAL,
    payload: data,
  };
};
const addComplementRequestApprovalUnsuccessfully = (err) => {
  return {
    type: ADD_COMPLEMENT_REQUEST_APPROVAL_ERROR,
    payload: err,
  };
};

const getLastComplementRequestApprovalStart = () => {
  return {
    type: GET_COMPLEMENT_REQUEST_APPROVAL_LAST_START,
  };
};
const getLastComplementRequestApprovalSuccessfully = (data) => {
  return {
    type: GET_COMPLEMENT_REQUEST_APPROVAL_LAST,
    payload: data,
  };
};
const getLastComplementRequestApprovalUnsuccessfully = (err) => {
  return {
    type: GET_COMPLEMENT_REQUEST_APPROVAL_LAST_ERROR,
    payload: err,
  };
};

const getComplementRequestListByReqeuestStart = () => {
  return {
    type: GET_COMPLEMENT_REQUEST_APPROVAL_LIST_BY_REQUEST_START,
  };
};
const getComplementRequestListByReqeuestSuccessfully = (data) => {
  return {
    type: GET_COMPLEMENT_REQUEST_APPROVAL_LIST_BY_REQUEST,
    payload: data,
  };
};
const getComplementRequestListByReqeuestUnsuccessfully = (err) => {
  return {
    type: GET_COMPLEMENT_REQUEST_APPROVAL_LIST_BY_REQUEST_ERROR,
    payload: err,
  };
};

const clearComplementRequestApprovalContent = () => {
  return {
    type: CLEAR_COMPLEMENT_REQUEST_APPROVAL,
  };
};

export const createComplementRequestApproval = (
  complementRequestApproval,
  callback,
  message
) => {
  return (dispatch) => {
    dispatch(addComplementRequestApprovalStart());
    return apiService
      .post(complementRequestApprovalAddPath(), complementRequestApproval)
      .then((response) => {
        dispatch(addComplementRequestApprovalSuccessfully(response.data));
        callback();
        createNotification(
          notificationTypeInfo,
          message.requestTitle,
          message.successComplementRequired
        );
      })
      .catch((err) => {
        dispatch(
          addComplementRequestApprovalUnsuccessfully(err?.response?.data)
        );
        createNotification(
          notificationTypeError,
          message.complementError,
          err?.response?.data?.message
        );
      });
  };
};

export const findLastComplementRequestApprovalByRequestId = (id) => {
  return (dispatch) => {
    dispatch(getLastComplementRequestApprovalStart());
    return apiService
      .get(complementRequestApprovalFindLastByRequestPath(id))
      .then((response) => {
        dispatch(getLastComplementRequestApprovalSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(
          getLastComplementRequestApprovalUnsuccessfully(err?.response?.data)
        );
      });
  };
};

export const findAllComplementRequestsByRequestId = (id) => {
  return (dispatch) => {
    dispatch(getComplementRequestListByReqeuestStart());
    return apiService
      .get(complementRequestApprovalFindAllByRequestPath(id))
      .then((response) => {
        dispatch(getComplementRequestListByReqeuestSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(
          getComplementRequestListByReqeuestUnsuccessfully(err?.response?.data)
        );
      });
  };
};

export const clearComplementRequestApproval = () => {
  return (dispatch) => {
    dispatch(clearComplementRequestApprovalContent());
  };
};
